<template>
  <div class="m-wap-main">
    <div class="m-wap-area">
      <div class="c-form c-wap-form">
        <div
          class="m-area"
          v-for="o in list"
          :key="o.fieldName"
          :class="{ 'text-shuang': o.displayName.length > 6 }"
        >
          <div
            class="form-row"
            :style="{ background: configStyle&&configStyle.formRowBgColor }"
          >
            <div class="form-label" :style="{ color: configStyle&&configStyle.formColor }">
              {{ o.displayName }}
            </div>
            <div class="form-contro">
              <input
                type="text"
                class="form-input"
                disabled
                v-model="o.model"
                :style="{
                  background: configStyle&&configStyle.formRowBgColor,
                  color: configStyle&&configStyle.formColor
                }"
              />
            </div>
          </div>
        </div>

        <div
          class="form-row"
          :style="{ background: configStyle&&configStyle.formRowBgColor }"
          v-if="oauthInfo && oauthInfo.qq"
        >
          <div class="form-label" :style="{ color: configStyle&&configStyle.formColor }">
            QQ
          </div>
          <div class="form-contro pull-relative">
            <input
              type="text"
              class="form-input"
              v-model="bindInfo.qq.nickname"
              readonly
              :style="{
                background: configStyle&&configStyle.formRowBgColor,
                color: configStyle&&configStyle.formColor
              }"
              v-if="bindInfo.qq"
            />
            <input
              type="text"
              class="form-input"
              readonly
              placeholder="未绑定"
              :style="{
                background: configStyle&&configStyle.formRowBgColor,
                color: configStyle&&configStyle.formColor
              }"
              v-if="!bindInfo.qq"
            />
            <div
              class="form-text"
              @click="unBindThird('qq')"
              :style="{
                background: configStyle&&configStyle.themeColor,
                color: configStyle&&configStyle.saveBbtnColor
              }"
              v-if="bindInfo.qq"
            >
              解除绑定
            </div>
            <div
              class="form-text"
              @click="bindThird('qq')"
              :style="{
                background: configStyle&&configStyle.themeColor,
                color: configStyle&&configStyle.saveBbtnColor
              }"
              v-if="!bindInfo.qq"
            >
              绑定
            </div>
          </div>
        </div>
        <div
          class="form-row"
          :style="{ background: configStyle&&configStyle.formRowBgColor }"
          v-if="oauthInfo && oauthInfo.wechat"
        >
          <div class="form-label" :style="{ color: configStyle&&configStyle.formColor }">
            微信
          </div>
          <div class="form-contro pull-relative">
            <input
              type="text"
              class="form-input"
              v-model="bindInfo.wechat.nickname"
              readonly
              :style="{
                background: configStyle&&configStyle.formRowBgColor,
                color: configStyle&&configStyle.formColor
              }"
              v-if="bindInfo.wechat"
            />
            <input
              type="text"
              class="form-input"
              readonly
              placeholder="未绑定"
              :style="{
                background: configStyle&&configStyle.formRowBgColor,
                color: configStyle&&configStyle.formColor
              }"
              v-if="!bindInfo.wechat"
            />
            <div
              class="form-text"
              @click="unBindThird('wechat')"
              :style="{
                background: configStyle&&configStyle.themeColor,
                color: configStyle&&configStyle.saveBbtnColor
              }"
              v-if="bindInfo.wechat"
            >
              解除绑定
            </div>
            <div
              class="form-text"
              @click="bindThird('wechat')"
              :style="{
                background: configStyle&&configStyle.themeColor,
                color: configStyle&&configStyle.saveBbtnColor
              }"
              v-if="!bindInfo.wechat"
            >
              绑定
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="show">
      <div class="c-confirm-alert wap">
        <div class="ca-header">
          <span class="icon icontemp stemp-close" @click="hideAlert()"></span>
        </div>
        <div class="ca-main">
          解绑后该{{ unstr == "qq" ? "QQ" : "微信" }}号将无法用户账号登陆<br />
          确定解绑么？
        </div>
        <div class="ca-footer">
          <button
            class="m-button-btn confirm"
            :style="{
              background: configStyle&&configStyle.themeColor,
              color: configStyle&&configStyle.saveBbtnColor,
              border: `1px solid ${
                configStyle&&configStyle.borderColor ? configStyle.themeColor : '#1665d8'
              }`
            }"
            @click="confirmUnBind()"
          >
            确定
          </button>
          <button class="m-button-btn cancel" @click="hideAlert()">
            我再想想
          </button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { $subscriber } from "fire-wind-water/tools/subscriber";
import { cr } from "fire-wind-water/core";
import { URLS } from "fire-wind-water/url";
import { sess, tenantId } from "../../common/sbase";
import member from "../../services/member";

export default {
  name: "Account",
  data() {
    return {
      list: [],
      bindInfo: {},
      oauthInfo: {},
      isLoading: true,
      show: false,
      unstr: "",
      token: URLS.getURL("token"),
      errorText: URLS.getURL("error"),
      configStyle: null
    };
  },
  methods: {
    init() {
      $subscriber.subscribe("s-member-contact", data => {
        this.initList(data[0], data[1]);
        this.isLoading = false;
        window.$sk.loading.hide();
      });
      $subscriber.on("s-contact-init", o => {
        this.isLoading = false;
        this.bindInfo = o.bindInfo;
        this.memberBind();
      });
    },
    initList(m, o) {
      this.bindInfo = o.bindInfo;
      this.oauthInfo = m.oauthInfo;
      if (!this.bindInfo || cr.isArray(this.bindInfo)) {
        this.bindInfo = {};
      }
      this.list = [];
      cr.each(m.items, d => {
        if (d.isLogin == 1) {
          d.model = o.fieldInfo[d.fieldName] || null;
          this.list.push(d);
        }
      });
    },
    hideAlert() {
      this.show = false;
    },
    memberBind() {
      if (!this.bindInfo.wechat && this.token) {
        const info = {
          tenantId: tenantId,
          sess: sess,
          token: this.token
        };
        member.bind(info).subscribe(data => {
          if (data.result == "0") {
            this.$message.success("绑定成功");
            $subscriber.emit("s-contact-get");
          } else {
            this.$message.error(data.desc);
          }
        });
      }
    },
    bindThird(s) {
      let loginUrl = URLS.updateParam("sess", sess, this.oauthInfo[s].loginUrl);
      loginUrl = URLS.updateParam(
        "return_url",
        encodeURIComponent(window.location.href),
        loginUrl
      );
      window.location.href = loginUrl;
    },
    unBindThird(s) {
      this.show = true;
      this.unstr = s;
    },
    confirmUnBind() {
      const info = {
        provider: this.unstr,
        sess: sess
      };
      this.isLoading = true;
      member.unbind(info).subscribe(data => {
        if (data.result == "0") {
          this.$message.success("解绑成功");
          this.show = false;
          this.token = null;
          $subscriber.emit("s-contact-get");
        } else {
          this.$message.error(data.desc);
          this.isLoading = false;
        }
      });
    }
  },
  created() {
    this.init();
    if (this.errorText) {
      this.$message.error(decodeURIComponent(this.errorText));
    }
//    this.configStyle = ck.cookie("configStyle");
    $subscriber.subscribe("config-style", data=>{
      this.configStyle = data;
    });
  }
};
</script>

<style scoped></style>
